import {Routes} from '@angular/router';
import {equitySaleRoutes} from './equity.sale.order/equity.sale.routes';

export const equityManagementRoutes: Routes = [
  {
    path: 'memberEquity',
    loadComponent: () => import('./equity-management.component').then(m => m.EquityManagementComponent),
    data: { title: '权益管理' },
    children: [
      {
        path: 'equity.mgr',
        loadComponent: () => import('./equity.mgr/equity.mgr.component').then(m => m.EquityMgrComponent),
        data: {key:"01J7Q7BQ80Y8ESTE0A7HX1QS7E", keep: true,title: "普通权益"},
      },
      {
        path: 'equity.gift.order',
        loadComponent: () => import('./equity.gift.order/equity.gift.order.component').then(m => m.EquityGiftOrderComponent),
        data: {key:"01J7Q7CC5YJTVSF51AD62HNWR7", keep: true,title: "礼品领取单"},

      },
      {
        path: 'add.gift.order',
        loadComponent: () => import('./equity.gift.order/add.gift.order/add.gift.order.component').then(m => m.AddGiftOrderComponent),
        data: { title: '礼品领取明细' },
      },
      {
        path: 'add.gift.order/:orderId',
        loadComponent: () => import('./equity.gift.order/add.gift.order/add.gift.order.component').then(m => m.AddGiftOrderComponent),
        data: { title: '礼品领取明细' },
      },
      ...equitySaleRoutes,
      {
        path: 'gift.equity',
        loadComponent: () => import('./gift.equity/gift.equity.component').then(m => m.GiftEquityComponent),
        data: {key:"01J81J99GP24B0EC0BFA06XSDT", keep: true,title: "礼品权益"},
      },
      {
        path: 'cashback.equity',
        loadComponent: () => import('./cashback.equity/cashback.equity.component').then(m => m.CashbackEquityComponent),
        data: {key:"01J7Q7CKW8QRMW5BB6V8QAPW8S", keep: true,title: "返现权益"},
      },
      {
        path: 'equity.release',
        loadComponent: () => import('./equity.release/equity.release.component').then(m => m.EquityReleaseComponent),
        data: {key:"01J8147KAT2KR6292XH5RQVRF2", keep: true,title: "权益上架"},
      },
      {
        path: 'equity.recommendation',
        loadComponent: () => import('./equity.recommendation/equity.recommendation.component').then(m => m.EquityRecommendationComponent),
        data: {key:"01KJY4ZHTKKBPMKZY7EX7DJV4T", keep: true,title: "权益推广"},
      },
      {
        path: 'equity.cashback.order',
        loadComponent: () => import('./equity.cashback.order/equity.cashback.order.component').then(m => m.EquityCashbackOrderComponent),
        data: {key:"01J8GV5KNZJSJW5THEN5C0K4DP", keep: true,title: "返现领取单"},
      },
      {
        path: 'add.cashback.order',
        loadComponent: () => import('./equity.cashback.order/add.cashback.order/add.cashback.order.component').then(m => m.AddCashbackOrderComponent),
        data: {title: "返现领取单明细"},
      },
      {
        path: 'add.cashback.order/:orderId',
        loadComponent: () => import('./equity.cashback.order/add.cashback.order/add.cashback.order.component').then(m => m.AddCashbackOrderComponent),
        data: {title: "返现领取单明细"},
      },
      {
        path: 'equity.gift.mgr',
        loadComponent: () => import('./equity.gift.mgr/equity.gift.mgr.component').then(m => m.EquityGiftMgrComponent),
        data: {title: "礼品管理"},
      },
      {
        path: 'add.equity.gift',
        loadComponent: () => import('./equity.gift.mgr/add.equity.gift.goods/add.equity.gift.goods.component').then(m => m.AddEquityGiftGoodsComponent),
        data: {key: "01JMVW8PG5PDP8R51HD10YFEHA", keep: true,title: "添加权益礼品"},
      },
      {
        path: 'add.equity.gift/:goodsId',
        loadComponent: () => import('./equity.gift.mgr/add.equity.gift.goods/add.equity.gift.goods.component').then(m => m.AddEquityGiftGoodsComponent),
        data: {key: "01JMVW8W3V23V91QADSYN5EV46", keep: true,title: "添加权益礼品"},
      },
      {
        path: 'wy.equity',
        loadComponent: () => import('./wy.equity/wy.equity.component').then(m => m.WyEquityComponent),
        data: { title: '物业费返利权益' },
      },
      {
        path: 'parking.equity',
        loadComponent: () => import('./parking.equity/parking.equity.component').then(m => m.ParkingEquityComponent),
        data: { title: '停车费返利权益' },
      },
      {
        path: 'electricity.equity',
        loadComponent: () => import('./electricity.equity/electricity.equity.component').then(m => m.ElectricityEquityComponent),
        data: { title: '电费返利权益' },
      },
      {
        path: 'water.equity',
        loadComponent: () => import('./water.equity/water.equity.component').then(m => m.WaterEquityComponent),
        data: { title: '水费返利权益' },
      },
      {
        path: 'gas.equity',
        loadComponent: () => import('./gas.equity/gas.equity.component').then(m => m.GasEquityComponent),
        data: { title: '燃气费返利权益' },
      },
      {
        path: 'release.equity.equity',
        loadComponent: () => import('./release.equity/release.equity.component').then(m => m.ReleaseEquityComponent),
        data: { title: '预购权益' },
      },
      {
        path: 'partner.equity',
        loadComponent: () => import('./partner.equity/partner.equity.component').then(m => m.PartnerEquityComponent),
        data: {title: '方案权益'},
      },
    ]
  },
];
